"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanoramicViewTourWorker = void 0;
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
var tsyringe_1 = require("tsyringe");
var panoramic_view_tour_service_1 = require("./panoramic-view-tour.service");
var bootstrap = require("bootstrap");
var rxjs_1 = require("rxjs");
var PanoramicViewTourWorker = /** @class */ (function () {
    function PanoramicViewTourWorker(panoramicViewtourService) {
        var _this_1 = this;
        this.panoramicViewtourService = panoramicViewtourService;
        this.initPanoramicView = function (id, isApplyAnimate) {
            if (isApplyAnimate === void 0) { isApplyAnimate = false; }
            var animateObj = PanoramicViewTourWorker_1.ANIMATEVALUES;
            ajLoading(true);
            if (_this_1.viewer) {
                _this_1.viewer.destroy();
            }
            _this_1.panoramicViewtourService
                .getPanoramicViewBase64ByIdAsync(id)
                .then(function (_a) {
                var base64 = _a.result;
                _this_1.viewer = pannellum.viewer('panorama', __assign({ type: 'equirectangular', panorama: base64, autoLoad: true, showControls: false }, (isApplyAnimate ? { pitch: animateObj.pitch.start, hfov: animateObj.hfov.start, yaw: animateObj.yaw.start } : {})));
                _this_1.viewer.on('load', function () {
                    ajLoading(false);
                    isApplyAnimate && _this_1.startAnimatedViewer();
                });
                _this_1.viewer.on('error', function (e) {
                    ajLoading(false);
                    _this_1.tourList.addClass('slide-in');
                    _this_1.showAlertMessage(e);
                });
                $('.panoramic-view-item .panorami-item.active').removeClass('active');
                $("[data-id=".concat(id, "]")).addClass('active');
            })
                .catch(function (error) {
                ajLoading(false);
                _this_1.showAlertMessage(error);
            });
        };
        this.renderRating = function () {
            var lstInputRating = $('input.custom-rating:not(.rating-loaded)');
            if (lstInputRating && (lstInputRating === null || lstInputRating === void 0 ? void 0 : lstInputRating.length) > 0) {
                lstInputRating.addClass('rating-loaded');
                requestAnimationFrame(function () { return lstInputRating.rating(); });
            }
        };
        this.initCarouselEvent = function () {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var _this = _this_1;
            _this.panoramicListCarousel.on('slid.bs.carousel', function () {
                _this.updateCarouselControls();
            });
            _this.adjustCarouselItems();
            var resizeObserable = (0, rxjs_1.fromEvent)(window, 'resize').pipe((0, rxjs_1.throttleTime)(100));
            resizeObserable.subscribe(function () { return _this.adjustCarouselItems(); });
        };
        this.adjustCarouselItems = function () {
            var $carouselInner = $('#panoramicListCarousel .carousel-inner');
            var cards = $('#panoramicListCarousel .panoramic-view-item');
            var itemsPerSlide = window.innerWidth >= PanoramicViewTourWorker_1.DESKTOP_WIDTH ? 5 :
                window.innerWidth >= PanoramicViewTourWorker_1.TABLET_WIDTH ? 3 : 1;
            $carouselInner.empty();
            for (var i = 0; i < cards.length; i += itemsPerSlide) {
                var isFirst = i === 0 ? 'first active' : '';
                var isLast = i + itemsPerSlide >= cards.length ? 'last' : '';
                var $slide = $('<div>').addClass("carousel-item ".concat(isFirst, " ").concat(isLast));
                var $innerSlideWrapper = $('<div>').addClass('panoramic-view-slider');
                for (var j = i; j < i + itemsPerSlide && j < cards.length; j++) {
                    var nextIndex = j + 1;
                    if (nextIndex >= i + itemsPerSlide || nextIndex >= cards.length) {
                        $(cards[j]).find('.splitter').remove();
                    }
                    $innerSlideWrapper.append($(cards[j]).detach());
                }
                $slide.append($innerSlideWrapper);
                $carouselInner.append($slide);
            }
            _this_1.updateCarouselControls();
        };
        this.updateCarouselControls = function () {
            var $carousel = _this_1.panoramicListCarousel;
            var $firstSlideActive = $carousel.find('.carousel-item.first.active');
            var $lastSlideActive = $carousel.find('.carousel-item.last.active');
            // Disable prev button if the first slide is active
            var $prevControl = $carousel.find('.carousel-control-prev');
            if ($firstSlideActive.length > 0) {
                $prevControl.hide();
            }
            else {
                $prevControl.show();
            }
            // Disable next button if the last slide is active
            var $nextControl = $carousel.find('.carousel-control-next');
            if ($lastSlideActive.length > 0) {
                $nextControl.hide();
            }
            else {
                $nextControl.show();
            }
        };
        this.onChangePanoramicView = function (id) {
            _this_1.initPanoramicView(id);
        };
        this.showAlertMessage = function (message) {
            $('.noti-message').empty();
            $('.noti-message').append(message);
            $("#mdlAlertMessage").modal("show");
        };
        $(function () {
            _this_1.intiData();
            _this_1.initEvent();
        });
    }
    PanoramicViewTourWorker_1 = PanoramicViewTourWorker;
    PanoramicViewTourWorker.prototype.intiData = function () {
        var _this = this;
        _this.panoramicListCarousel = $('#panoramicListCarousel');
        _this.tourList = $('.tour-list');
    };
    PanoramicViewTourWorker.prototype.initEvent = function () {
        var _this = this;
        _this.renderRating();
        var tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        tooltipTriggerList.forEach(function (tooltipTriggerEl) { return new bootstrap.Tooltip(tooltipTriggerEl); });
        var activePanoramicViewItem = $('.panoramic-view-item .panorami-item.active');
        _this.initPanoramicView(activePanoramicViewItem.data('id'), true);
        _this.initCarouselEvent();
    };
    // Start Animated Viewer
    PanoramicViewTourWorker.prototype.startAnimatedViewer = function () {
        var _this_1 = this;
        var animateObj = PanoramicViewTourWorker_1.ANIMATEVALUES;
        this.viewer.lookAt(animateObj.pitch.end, animateObj.yaw.end, animateObj.hfov.mid, 3000, function () {
            _this_1.tourList.addClass('slide-in');
        });
    };
    var PanoramicViewTourWorker_1;
    PanoramicViewTourWorker.DESKTOP_WIDTH = 1200;
    PanoramicViewTourWorker.TABLET_WIDTH = 992;
    PanoramicViewTourWorker.ANIMATEVALUES = {
        pitch: { start: -90, end: 0 },
        yaw: { start: 0, end: 0 },
        hfov: { start: 120, mid: 100, end: 0 },
        Hfov: { min: 90, max: 160 },
        autoRotate: -4,
    };
    PanoramicViewTourWorker = PanoramicViewTourWorker_1 = __decorate([
        (0, tsyringe_1.singleton)(),
        __metadata("design:paramtypes", [panoramic_view_tour_service_1.default])
    ], PanoramicViewTourWorker);
    return PanoramicViewTourWorker;
}());
exports.PanoramicViewTourWorker = PanoramicViewTourWorker;
